export default __webpack_public_path__ + "326dc26ee9ac263fc4ffa3b9eff12de5.svg";